import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {Person} from '../../types/person/person';
import {Pageable} from '../../types/common/pageable';
import {BasicPersonData} from '../../types/person/basic-person-data';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class PersonRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('consultants');
  }

  getPerson(id: number): Observable<Person> {
    return this.http.get<any>(this.getEndpoint([String(id), 'detail']));
  }

  getPersonFromAllPersons(id: number): Observable<Person> {
    return this.http.get<Person>(this.getEndpoint([String(id), 'detail', 'FromAll']));
  }

  /**
   * Update person data and profile image.
   * @param {Person} person
   * @param {File} image
   * @returns {Observable<Person>}
   */
  save(person: Person, image: File) {
    const formData: FormData = new FormData();

    if (image) {
      formData.append('file_data', image, image.name);
    }

    const dtoData = new Blob([JSON.stringify(person)], {
      type: 'application/json',
    });

    formData.append('detailData', dtoData);
    if (person.id) {
      return this.http.put<Person>(this.getEndpoint([String(person.id), 'detail']), formData);
    }
    return this.http.post<Person>(this.getEndpoint(['detail']), formData);
  }

  findBy(query: string, page: Pageable): Observable<BasicPersonData[]> {
    const params: HttpParams = new HttpParams()
      .set('query', query)
      .set('size', String(page.size));
    return this.http.get<BasicPersonData[]>(this.getEndpoint(['find']), {params});
  }

  findFromAllBy(query: string, page: Pageable): Observable<BasicPersonData[]> {
    const params: HttpParams = new HttpParams()
      .set('query', query)
      .set('size', String(page.size));
    return this.http.get<BasicPersonData[]>(this.getEndpoint(['findFromAll']), {params});
  }

  public getProfileImageUrl(consultantId): Observable<string> {
    const options = {responseType: 'text'};
    // @ts-ignore
    return this.http.get<string>(this.getEndpoint(['image', String(consultantId)]), options);
  }

}
